import React from 'react';
import ReactDOM from 'react-dom/client';
import Builder from "./Containers/Builder/Builder";
import "./assets/styles/cookie.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Builder />
);

